import React, { useState, useEffect, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import {
  NumToFa,
  capitalizeFirstLetters,
  convertToPersian,
  formatPrice,
} from "../Functions/TextTransform";
import { useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import SelectedFiltersOverflow from "./SelectedFiltersOverflow";

export default function FilteredComponentHeader({
  setShowAllFilters,
  showAllFilters,
  selectedSort,
  setSelectedSort,
  filteredProducts,
  setSelectedItems,
  selectedItems,
  handleRemoveItem,
  setCheckedItems,
  fetchFilteredProducts,
  syncProductLayout = false,
  filterBarRef,
  priceLevels = [],
}) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname.split("").slice(1, 3).join("")
  );
  const [isScrolled, setIsScrolled] = useState(false);
  let uniqueProducts = filteredProducts.reduce((acc, current) => {
    const isExist = acc.find(
      (item) =>
        item?.ProductName === current?.ProductName &&
        item?.ColorId === current?.ColorId
    );

    // اگر محصول مشابهی پیدا نشد، آن را به لیست خروجی اضافه می‌کنیم
    if (!isExist) {
      acc.push(current);
    }

    return acc;
  }, []);

  useEffect(() => {
    if (pageLanguage !== location.pathname.split("").slice(1, 3).join("")) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);

console.log(`selectedItems`, selectedItems);
  useEffect(() => {
    if (syncProductLayout) {
      setIsScrolled(false);
      return undefined;
    }

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // پاک کردن event listener هنگام از بین رفتن کامپوننت
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [syncProductLayout]);

  const normalizeUrlName = (name) => name?.replace(/\s+/g, " ").trim();

  const getFilterDisplayText = (item) => {
    const isPriceFilter = item.Key === "price" || item.ProductPriceLevelId;
console.log(`item`, item);
    if (isPriceFilter) {
      let label =
        pageLanguage === "en"
          ? item.LevelEnTitle || item.UrlName
          : item.LevelTitle || item.UrlName;

      if (!item.LevelTitle && !item.LevelEnTitle && priceLevels.length) {
        const priceObj = priceLevels.find(
          (price) => normalizeUrlName(price.UrlName) === normalizeUrlName(item.UrlName)
        );
        if (priceObj) {
          label = pageLanguage === "en" ? priceObj.LevelEnTitle : priceObj.LevelTitle;
        }
      }

      if (pageLanguage === "en") {
        return capitalizeFirstLetters(label);
      }

      return /\d/.test(label)
        ? convertToPersian(formatPrice(label), pageLanguage)
        : convertToPersian(capitalizeFirstLetters(label), pageLanguage);
    }

    return pageLanguage === "en" ? capitalizeFirstLetters(item.UrlName) : t(item.UrlName);
  };

  const handleClearAllFilters = () => {
    const searchParams = new URLSearchParams();
    setSelectedItems([]);
    setCheckedItems({});
    fetchFilteredProducts({ searchParams });
    const currentUrl = new URL(window.location.href);
    currentUrl.search = "";
    window.history.replaceState(null, "", currentUrl.toString());
  };

  const orderedSelectedItems = useMemo(() => [...selectedItems].reverse(), [selectedItems]);

  const selectedFilterChipItems = orderedSelectedItems.map((item, index) => (
    <li key={`${item.Key || "filter"}-${item.UrlName}-${index}`} className="filter_container filter_container_Header">
      <div className="dropdown">
        <button type="button" className="dropdown_btn btn btn-primary">
          <span style={{ whiteSpace: "nowrap" }}>{getFilterDisplayText(item)}</span>
               <button
                            type="button"
                            style={{width: "2px", marginBottom:"0.2rem"}}
                            className="btn-close"
                            aria-label="Close"
                           onClick={(e) => {
                           e.stopPropagation();
                           handleRemoveItem(item.UrlName);
                          }}
                          />
        </button>
      </div>
    </li>
  ));

  if (selectedItems.length > 0) {
    selectedFilterChipItems.push(
      <li key="filter_clear" className="filter_container filter_container_clear_all">
        <div className="dropdown">
          <button type="button" className="dropdown_btn btn btn-primary" onClick={handleClearAllFilters}>
            <p>{i18n.language === "fa" ? "حذف همه" : "CLEAR ALL"}</p>
          </button>
        </div>
      </li>
    );
  }

  const selectedFiltersList = (
    <ul className="collection_page_selected_filters_list">{selectedFilterChipItems}</ul>
  );

  if (syncProductLayout) {
    return (
      <div
        className="Product_page_filters_fix_container Product_page_filter Product_page_filter-collection"
        ref={filterBarRef}
      >
        <div
          className={`Product_page_filters_container Product_page_filters_container_new${
            showAllFilters && !isTabletOrMobile
              ? " products_page_toolbar_sidebar_open collection_page_toolbar_sidebar_open"
              : ""
          }`}
          style={{ width: "100%" }}
        >
          <div className="Product_page_filters">
            <div
              className="filters_container filters_container_show"
              style={{
                width: showAllFilters && !isTabletOrMobile ? undefined : "7rem",
              }}
            >
              <div className="filter_container filter_container_all_filter">
                <div title="" className="dropdown">
                  <button
                    aria-expanded="false"
                    type="button"
                    className="dropdown_btn dropdown-toggle btn btn-primary"
                    onClick={() => setShowAllFilters(!showAllFilters)}
                  >
                    {(!showAllFilters || isTabletOrMobile) && <p>{t("Filters")}</p>}
                    {showAllFilters && !isTabletOrMobile && <p>{t("Hide Filters")}</p>}
                    <div className="select_control_all_filters img-fluid"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <SelectedFiltersOverflow
            filters={selectedFilterChipItems}
            showAllFilters={showAllFilters}
            pageLanguage={pageLanguage}
            className="collection_page_selected_filters"
          />

          <div className="Product_page_sort products_page_toolbar_sort">
            <div className="filters_container filters_container_items_num">
              {!!uniqueProducts?.length && (
                <p>
                  {NumToFa(uniqueProducts?.length, pageLanguage)}&nbsp;
                  {t("product_Items")}
                </p>
              )}
            </div>
            <div className="Product_page_sort_select products_page_toolbar_sort_select">
              <div className="sort_dropdown_container">
                <Dropdown autoClose="outside" title="" align="end">
                  <Dropdown.Toggle className="dropdown_btn">
                    <label className="select_label">{t("Sort By: ")}</label>
                    {selectedSort !== undefined && <p>{t(selectedSort)}</p>}
                    <div className="select_control_handle_close img-fluid" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="filter_color_items"
                    style={{ direction: i18n.language === "fa" ? "" : "rtl" }}
                  >
                    <Dropdown.Item
                      as={Button}
                      onClick={() => setSelectedSort("New")}
                      style={{ position: "relative" }}
                    >
                      <label
                        className={
                          i18n.language === "fa" ? "radio_style_type_fa" : "radio_style_type"
                        }
                      >
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort1"
                          style={{ position: "absolute" }}
                          checked={selectedSort === "New"}
                        />
                        <label htmlFor="sort1">{t("New")}</label>
                      </label>
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Button}
                      onClick={() => setSelectedSort("Price, High to Low")}
                    >
                      <label
                        className={
                          i18n.language === "fa" ? "radio_style_type_fa" : "radio_style_type"
                        }
                      >
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort2"
                          checked={selectedSort === "Price, High to Low"}
                        />
                        <label htmlFor="sort2">
                          {i18n.language === "fa"
                            ? "قیمت ، از گران به ارزان"
                            : "Price, High to Low"}
                        </label>
                      </label>
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Button}
                      onClick={() => setSelectedSort("Price, Low to High")}
                    >
                      <label
                        className={
                          i18n.language === "fa" ? "radio_style_type_fa" : "radio_style_type"
                        }
                      >
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort3"
                          checked={selectedSort === "Price, Low to High"}
                        />
                        <label htmlFor="sort3">
                          {i18n.language === "fa"
                            ? "قیمت ، از ارزان به گران"
                            : "Price, Low to High"}
                        </label>
                      </label>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const selectedFiltersListLegacy = (
    <ul
      className="collection_page_selected_filters_list"
      style={{
        display: "flex",
        paddingBottom: "1rem",
        width: "100%",
        flexWrap: "wrap",
        rowGap: "1rem",
      }}
    >
      {selectedItems.map((item, index) => (
        <li
          key={index}
          className="filter_container filter_container_Header"
          style={{ display: "inline-block", width: "auto" }}
        >
          <div className="dropdown">
            <button
              type="button"
              className="dropdown_btn btn btn-primary"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span style={{ whiteSpace: "nowrap" }}>{getFilterDisplayText(item)}</span>
              <span
                className="select_control_delete_filter_filterLeft 1"
                style={{
                  cursor: "pointer",
                  marginLeft: "8px",
                  color: "red",
                  fontWeight: "bold",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveItem(item.UrlName);
                }}
              ></span>
            </button>
          </div>
        </li>
      ))}

      {selectedItems.length > 0 && (
        <li
          key="filter_clear"
          className="filter_container filter_container_clear_all"
          style={{ width: "6rem" }}
        >
          <div className="dropdown">
            <button
              type="button"
              className="dropdown_btn btn btn-primary"
              onClick={handleClearAllFilters}
            >
              <p>{i18n.language === "fa" ? "حذف همه" : "CLEAR ALL"}</p>
            </button>
          </div>
        </li>
      )}
    </ul>
  );

  return (
    <>
      <div 
       className={`Product_page_filters_fix_container Product_page_filter Product_page_filter-collection ${
        isScrolled ? 'scrool_top' : ''
      }`}
       style={{minHeight:"3.45rem" }}>
        <div className="Product_page_filters">
          <div className="filters_container filters_container_show">
            <div className="filter_container filter_container_all_filter">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                  onClick={() => setShowAllFilters(!showAllFilters)}
                >
                  {(!showAllFilters || isTabletOrMobile) && (
                    <p>{t("Filters")}</p>
                  )}
                  {showAllFilters && !isTabletOrMobile && (
                    <p>{t("Hide Filters")}</p>
                  )}
                  <div className="select_control_all_filters img-fluid"></div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="Product_page_sort" style={{alignItems:"center" , gap:"1rem"}}>
          <div className="filters_container filters_container_items_num">
            {!!uniqueProducts?.length && (
              <p>
                {NumToFa(uniqueProducts?.length, pageLanguage)}&nbsp;
                {t("product_Items")}
              </p>
            )}
          </div>
          <div className="Product_page_sort_select 2">
            <div className="sort_dropdown_container">
              <Dropdown autoClose="outside" title="" align="end">
                <Dropdown.Toggle className="dropdown_btn">
                  <label className="select_label">{t("Sort By: ")}</label>
                  {selectedSort !== undefined && <p>{t(selectedSort)}</p>}
                  <div className="select_control_handle_close img-fluid" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="filter_color_items"
                  style={{ direction: i18n.language === "fa" ? "" : "rtl" }}
                >
                  <Dropdown.Item
                    as={Button}
                    onClick={() => setSelectedSort("New")}
                    style={{ position: "relative" }}
                  >
                    <label
                      className={
                        i18n.language === "fa"
                          ? "radio_style_type_fa"
                          : "radio_style_type"
                      }
                    >
                      <input
                        className="radio"
                        type="radio"
                        name="sort"
                        id="sort1"
                        style={{ position: "absolute" }}
                        checked={selectedSort === "New"}
                      />
                      <label htmlFor="sort1">{t("New")}</label>
                    </label>
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Button}
                    onClick={() => setSelectedSort("Price, High to Low")}
                  >
                  
                    <label
                      className={
                        i18n.language === "fa"
                          ? "radio_style_type_fa"
                          : "radio_style_type"
                      }
                    >
                      <input
                        className="radio"
                        type="radio"
                        name="sort"
                        id="sort2"
                        checked={selectedSort === "Price, High to Low"}
                      />
                      <label htmlFor="sort2">
                        {i18n.language === "fa"
                          ? "قیمت ، از گران به ارزان"
                          : "Price, High to Low"}
                      </label>
                    </label>
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Button}
                    onClick={() => setSelectedSort("Price, Low to High")}
                  >
                    <label
                      className={
                        i18n.language === "fa"
                          ? "radio_style_type_fa"
                          : "radio_style_type"
                      }
                    >
                      
                      <input
                        className="radio"
                        type="radio"
                        name="sort"
                        id="sort3"
                        checked={selectedSort === "Price, Low to High"}
                      />
                      <label htmlFor="sort3">
                        {i18n.language === "fa"
                          ? "قیمت ، از ارزان به گران"
                          : "Price, Low to High"}
                      </label>
                    </label>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div style={{display:"flex" , minHeight:"45px"}}>
      {showAllFilters &&
      
      <div style={{width:"25%"}}></div>
      }
        <div style={{width:"75%" , minHeight:"20px"}}>
          <div
            className="filters_container filters_container_Header flex_grow"
          >
            {selectedFiltersListLegacy}
          </div>
        </div>
      
      </div>
    </>
  );
}
